import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main>
        <section className="pt-28 md:pt-36 pb-10 md:pb-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 text-center">
            <p className="text-primary-500 font-label text-sm tracking-[0.15em] uppercase mb-3">
              Our Story
            </p>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-900 mb-4">
              About Ghalib Chai
            </h1>
            <p className="text-foreground-600 max-w-2xl mx-auto text-base md:text-lg">
              Where tradition meets tranquility — a tea house built on passion,
              quality, and the timeless art of hospitality.
            </p>
          </div>
        </section>

        <section className="py-12 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-16 md:mb-24">
              <div className="relative">
                <div className="aspect-[4/3] rounded-lg overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/afba8065016d507f2f8c8ff415707e60.jpeg"
                    alt="Elegant golden chai cup on red table"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div>
                <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5">
                  The Story Behind Every Cup
                </h2>
                <div className="space-y-4 text-foreground-700 text-base leading-relaxed">
                  <p>
                    Ghalib Chai was founded with a single mission: to create a
                    space where people could experience the true essence of
                    traditional chai. Named after the legendary Persian and Urdu
                    poet Mirza Ghalib, our tea house draws inspiration from his
                    love for beauty, conversation, and the simple pleasures of
                    life.
                  </p>
                  <p>
                    What started as a small corner stall has grown into a
                    beloved gathering place for tea enthusiasts, families, and
                    anyone seeking a moment of calm in their busy day. Our
                    signature Karak Chai has become a local favorite, drawing
                    visitors from across the city who come for the taste and
                    stay for the warmth.
                  </p>
                  <p>
                    We believe that chai is more than just a drink — it is a
                    ritual, a conversation starter, and a bridge between cultures.
                    Every cup we serve carries this philosophy.
                  </p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-16 md:mb-24">
              <div className="order-2 lg:order-1">
                <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5">
                  Our Philosophy
                </h2>
                <div className="space-y-4 text-foreground-700 text-base leading-relaxed">
                  <p>
                    At Ghalib Chai, we believe in three core principles: quality,
                    authenticity, and hospitality. We source our tea leaves
                    directly from trusted growers in Afghanistan and the Kashmir
                    region, ensuring that every batch meets our high standards.
                  </p>
                  <p>
                    Our menu is a celebration of both tradition and innovation.
                    While we honor classic recipes like Karak and Kashmiri Pink
                    Tea, we also explore new flavor combinations that surprise and
                    delight. Our saffron chai, rose cardamom blend, and iced
                    specialty teas have all become customer favorites.
                  </p>
                  <p>
                    We also believe in giving back. A portion of every green tea
                    pack sold supports local farming communities in the regions
                    where we source our leaves.
                  </p>
                </div>
              </div>
              <div className="order-1 lg:order-2 relative">
                <div className="aspect-[4/3] rounded-lg overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/80a0788029abf61cb1c5c31a4c3feda5.jpeg"
                    alt="Fresh parathas being prepared"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              {[
                { number: '10+', label: 'Tea Varieties' },
                { number: '5K+', label: 'Happy Customers' },
                { number: '3', label: 'Years of Service' },
                { number: '100%', label: 'Natural Ingredients' },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="text-center p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/60"
                >
                  <p className="font-heading text-3xl md:text-4xl font-bold text-primary-600 mb-1">
                    {stat.number}
                  </p>
                  <p className="text-foreground-600 text-sm">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}